import { DOC_PATHS } from 'utils/constants/routerPaths'

const NOTIF_TYPE = {
  DOC: 'NOTIF_DOC',
  FEAT: 'NOTIF_FEAT',
}

const notificationsList = [
  {
    id: 1,
    type: NOTIF_TYPE.DOC,
    title: 'Documentãção atualizada',
    description: 'Veja a documentação de como criar acessos para novos usuários.',
    created_at: '2025-10-08T15:00:00.000-03:00',
    action: () => {
      window.location.pathname = DOC_PATHS.USERS.PATH
      return null
    },
  },
]


export {
  NOTIF_TYPE,
  notificationsList,
}
